module.exports = __webpack_public_path__ + "static/media/busuu.f5d3abc7.png";